export const getCountryNumber = (country = 'US') => {
  switch (country) {
    case 'ITALY':
      return '+39';
    case 'US':
    default:
      return '+1';
  }
};
